import { ReactElement } from 'react'
import { Permission } from '../../../graphql'
import PermissionsCheck from 'components/PermissionsCheck'
import { useNavigate } from 'react-router-dom'
import {
	EuiPage,
	EuiPageBody,
	EuiPageHeader,
	EuiPageSection,
	EuiPanel,
	EuiSpacer,
} from '@equipmentshare/ds2'
import Button from '@mui/material/Button'
import { FilterConfig, SearchFilterExperience, UseFetchFilterOptionsQuery } from '@equipmentshare/dcf-search-filter-experience'
import { heapEvent } from '@equipmentshare/heaper'
import getColumns from './columns'
import useItemMastersDataQuery, { ItemMasterRow, ItemMastersSearchRequest } from './hooks/useItemMastersQuery'

const STATUS_OPTIONS = [
	{ id: 'true', label: 'Active', count: 0 },
	{ id: 'false', label: 'Inactive', count: 0 },
]

const filters: FilterConfig<ItemMastersSearchRequest>[] = [
	{
		field: 'isActive',
		label: 'Status',
		type: 'list',
		showByDefault: true,
	},
]

const useStatusFilterOptions: UseFetchFilterOptionsQuery<ItemMastersSearchRequest> = ( countBy ) => {
	if ( countBy === 'isActive' ) {
		return { isFetching: false, data: { filterOptions: STATUS_OPTIONS } }
	}
	return { isFetching: false, data: { filterOptions: [] } }
}

export default function ItemMasters(): ReactElement {
	const navigate = useNavigate()

	const handleAddItem = () => {
		heapEvent( 'Inventory - Item Master - List - Click - Add Item', {} )
		navigate( '/manage/item-masters/new' )
	}

	const columns = getColumns()

	return (
		<EuiPage paddingSize="l">
			<EuiPageBody>
				<EuiPageHeader
					pageTitle="Item Master"
					rightSideItems={[
						<PermissionsCheck permissionsToCheck={[ Permission.CanCreateItemMaster ]}>
							<Button variant="outlined" color="primary" onClick={handleAddItem}>
								Add Item
							</Button>
						</PermissionsCheck>,
					]}
					paddingSize="none"
				/>
				<EuiSpacer />
				<EuiPageSection paddingSize="none">
					<EuiPanel paddingSize="none" hasShadow={false}>
						<SearchFilterExperience<ItemMasterRow, ItemMastersSearchRequest>
							dataGridName="item-masters-table"
							filters={filters}
							filterStateMode="url"
							columns={columns}
							pageSizeOptions={[ 25, 50, 100 ]}
							useFetchQuery={useItemMastersDataQuery}
							useFetchFilterOptionsQuery={useStatusFilterOptions}
							searchPlaceholder="Search item masters..."
							getRowId={( row ) => row.id}
						/>
					</EuiPanel>
				</EuiPageSection>
			</EuiPageBody>
		</EuiPage>
	)
}
